// 详情
<template>
  <div class="form-single-fragment" style="position: relative">
    <el-form
      ref="formData"
      :model="formData"
      class="full-width-input"
      :rules="rules"
      style="width: 100%"
      label-width="100px"
      size="small"
      label-position="right"
      @submit.native.prevent
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="维护单：" prop="maintain_no">
            <span>{{ formData.maintain_no }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="设备类型：" prop="device_type">
            <!-- <el-select
              v-model="formData.device_type"
              placeholder="设备类型"
              clearable
              filterable
            >
              <el-option
                v-for="item in deveiceTypeArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
            <span>{{ formData.device_type__DictMap.name }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="设备编码：" prop="device_id">
            <el-select
              v-model="formData.device_id"
              placeholder="设备编码"
              clearable
              filterable
              @change="queryRefSlaveData()"
            >
              <el-option
                v-for="item in deveiceArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="设备名称：" prop="name">
            <span>{{ formData.name }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="规格型号：" prop="model">
            <span>{{ formData.model }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="维护状态：" prop="status">
            <el-radio-group v-model="formData.status">
              <el-radio label="OK">OK</el-radio>
              <el-radio label="NG">NG</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="维护日期：" prop="maintain_date">
            <el-date-picker
              v-model="formData.maintain_date"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="维护人：" prop="maintain_by">
            <el-select
              v-model="formData.maintain_by"
              placeholder="维护人"
              clearable
              filterable
              disabled
            >
              <el-option
                v-for="item in userArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <div class="Subtable">
          <div>设备维护项目</div>
          <el-table :data="columnArr" style="width: 100%">
            <el-table-column type="index" prop="index" label="序号">
            </el-table-column>
            <el-table-column prop="item_id" label="维护项目" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.item_id__DictMap">{{
                  scope.row.item_id__DictMap.name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="维护状态" width="240">
              <template slot-scope="scope">
                <el-radio-group v-model="scope.row.status">
                  <el-radio label="OK">OK</el-radio>
                  <el-radio label="NG">NG</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>
            <el-table-column prop="main_val" label="维护数据">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.main_val"
                  placeholder=""
                  size="small"
                  clearable
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-col :span="24" v-if="row && !row.id">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button size="small" @click="diaClose" :plain="true">
              取 消
            </el-button>
            <el-button size="small" type="primary" @click="onSave">
              确 认
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "LabelModel",
  props: {
    row: Object,
  },
  data() {
    return {
      formData: {
        maintain_no: null,
        device_type: null,
        device_type__DictMap: {},
        device_id: null,
        name: null,
        model: null,
        status: null,
        maintain_date: null,
        maintain_by: null,
      },
      columnArr: [],
      rules: {},

      deveiceArr: [],
      deveiceTypeArr: [],
      userArr: [],
    };
  },

  computed: {
    // isEdit () {
    //   return this.postId != null;
    // }
  },
  mounted() {},
  created() {
    if (this.row.id) {
      this.getInfo(this.row.id);
      this.getInfoArr(this.row.id);
    }
    this.getDevice();
    this.getDeviceType();
    this.getUser();
  },
  watch: {},
  methods: {
    // http://36.26.71.100:9097/admin/online/onlineOperation/viewByDatasourceId/dsDeviceMaintainHistory?datasourceId=1639883438855032832&dataId=97
    getInfo(dataId) {
      let params = {
        datasourceId: "1639883438855032832",
        dataId,
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/viewByDatasourceId/" +
          "dsDeviceMaintainHistory",
        "get",
        params
      );
      httpCall.then((res) => {
        this.formData = res.data;
      });
    },
    getInfoArr(dataId) {
      let params = {
        datasourceId: "1639883438855032832",
        relationId: "1639883742426173440",
        pageParam: { pageNum: 1, pageSize: 10 },
        filterDtoList: [
          {
            tableName: "zz_device_maintain_data",
            columnName: "history_id",
            filterType: 1,
            columnValue: dataId,
          },
        ],
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listByOneToManyRelationId/" +
          "dsDeviceMaintainHistory",
        "post",
        params
      );
      httpCall.then((res) => {
        this.columnArr = [];
        res.data.dataList.forEach((el) => {
          let obj = {};
          obj["history_id"] = el.deviceMaintainHistoryAndData__history_id;
          obj["item_id"] = el.deviceMaintainHistoryAndData__item_id;
          obj["item_id__DictMap"] =
            el.deviceMaintainHistoryAndData__item_id__DictMap;
          obj["status"] = el.deviceMaintainHistoryAndData__status;
          obj["type"] = el.deviceMaintainHistoryAndData__type;
          obj["main_val"] = el.deviceMaintainHistoryAndData__main_val;
          obj["type__DictMap"] = el.deviceMaintainHistoryAndData__type__DictMap;
          obj["code"] = el.deviceMaintainHistoryAndData__code;
          this.columnArr.push(obj);
          // if (key.includes('__')) newKey = key.split('__')[1];
        });
      });
    },
    getDevice() {
      let params = { dictId: "1697222112122507264", filterDtoList: [] };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listDict",
        "post",
        params
      );
      httpCall.then((res) => {
        this.deveiceArr = res.data;
      });
    },
    getDeviceType() {
      let params = { dictId: "1640239449600167936", filterDtoList: [] };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listDict",
        "post",
        params
      );
      httpCall.then((res) => {
        this.deveiceTypeArr = res.data;
      });
    },
    getUser() {
      let params = { dictId: "1440944417170001920", filterDtoList: [] };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listDict",
        "post",
        params
      );
      httpCall.then((res) => {
        this.userArr = res.data;
      });
    },
    // 联动下拉
    queryRefSlaveData() {
      let params = {
        formId: "1639884543701815296",
        columnValue: this.formData.device_id,
        columnKey: "device_id",
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineForm/queryRefSlaveData",
        "get",
        params
      );
      httpCall.then((res) => {
        console.log("联动下拉 res.data", res.data);
        this.formData = {
          ...this.formData,
          ...res.data.deviceMaintainHistoryAdd,
        };
        // this.columnArr = res.data.deviceMaintainHistoryAndData;
        this.columnArr = [];
        res.data.deviceMaintainHistoryAndData.forEach((el) => {
          let obj = {};
          obj["history_id"] = null;
          obj["item_id"] = el.deviceMaintainHistoryAndData__item_id;
          obj["item_id__DictMap"] =
            el.deviceMaintainHistoryAndData__item_id__DictMap;
          obj["status"] = null;
          obj["main_val"] = null;
          obj["type"] = el.deviceMaintainHistoryAndData__type;
          obj["type__DictMap"] = el.deviceMaintainHistoryAndData__type__DictMap;
          obj["code"] = el.deviceMaintainHistoryAndData__code;
          this.columnArr.push(obj);
          // if (key.includes('__')) newKey = key.split('__')[1];
        });
      });
    },
    onSave() {
      // this.formData.modelColumn = JSON.stringify(this.columnArr);
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            this.$emit("onUpdate", { dto: { ...this.formData } });
          } else {
            let { id, ...par } = this.formData;
            this.$emit("onAdd", {
              masterData: this.formData,
              arr: this.columnArr,
            });
          }
        } else {
          this.$message("请填写完整");
          return false;
        }
      });
    },
    diaClose() {
      this.$emit("diaClose");
    },
  },
};
</script>

<style lang="scss" scoped>
.Subtable {
  padding: 0 25px;
  box-sizing: border-box;
}
</style>
<style>
.el-table td > .cell span {
  display: inline-block !important;
}
::v-deep .el-radio__input {
  display: inline-block !important;
}
</style>
